import React from 'react';
import { useIntl } from 'react-intl';
import { Controller } from 'react-hook-form';

import styled from '@emotion/styled';
import { InputAdornment, TextField } from '@mui/material';

import { RegularText } from '../text';
import { addCommaToNumber } from '@/utils/functions';

export const InputWrapper = styled.div(() => ({
  position: 'relative',
  display: 'flex',
  flexDirection: 'column',
  gap: '1rem',
  minHeight: '8rem',
  width: '100%',
}));

export const RequiredMark = styled.span(({ theme }) => ({
  marginLeft: '0.2rem',
  color: theme.color.base_red,
}));

const InputBasic = ({
  control,
  name,

  type = 'text',
  label,
  required = false,
  multiline = false,
  placeholder,
  rows,
  inputMode,
  maxLength,
}) => {
  const intl = useIntl();

  return control ? (
    <Controller
      name={name}
      control={control}
      render={({ field, formState: { errors } }) => {
        return (
          <InputWrapper>
            <TextField
              {...field}
              helperText={errors[name]?.message}
              error={!!errors[name]}
              label={
                <>
                  <RegularText id={label} fontSize="1.6rem" />

                  {required && <RequiredMark>*</RequiredMark>}
                </>
              }
              multiline={multiline}
              placeholder={intl.formatMessage({ id: placeholder })}
              rows={rows}
              inputProps={{ maxLength: maxLength, inputMode: inputMode }}
              InputProps={{
                startAdornment: name === 'budget' && field.value !== '' && (
                  <InputAdornment position="start">
                    <div style={{ opacity: 0.4, padding: '0.2rem 0.4rem 0 0' }}>₩</div>
                  </InputAdornment>
                ),
              }}
              onChange={(e) => {
                const value = e.target.value;
                if (type === 'number') {
                  field.onChange(
                    addCommaToNumber(value.replace(/[^0-9.]/g, '').replace(/(\..*)\./g, '$1'))
                  );
                } else {
                  field.onChange(value);
                }
              }}
            />
          </InputWrapper>
        );
      }}
    />
  ) : (
    <TextField focused required={required} label={label} type={type} />
  );
};

export default InputBasic;
